import { useContext, useState } from "react";

import { Authorization } from "../../common/AuthorizationCpt";
import { getErrorValueResponse } from "../../common/error/Error";
// import LoadingSpinner from "../../images/icon_loading_green.gif";loading_gray
import LoadingSpinner from "../../images/loading_gray.gif";
import {
  BETA_FEATURES,
  HTTP_METHODS,
  PaymentModalStates,
} from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { formatMoney } from "../../utils/numbers";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { CurrencyContext } from "../CurrencyContext/CurrencyContext";
import { Container, MainButton, Row } from "./PaymentMethodStyles";

const PAYMENT_METHODS = {
  CASH: "contado",
  CREDIT: "credito",
  COLLECTION: "recaudo",
};

function PaymentMethod(props) {
  const {
    totalAmount,
    updatePaymentState,
    updatePayerItems,
    invoices,
    loadUpfrontManual,
    loadUpfront,
    toggleModal,
    setShowModalContadoInformation,
    getQuotationQuotedVolantes,
  } = props;
  const [waitingServerResponse, updateWaitingServerResponse] = useState(false);
  const [paymentMethod, updatePaymentMethod] = useState("none");
  const [useDollars] = useContext(CurrencyContext);

  const [messageError, updateMessageError] = useState("");
  const [showModalError, updateShowModalError] = useState(false);
  const toggleModalError = () => {
    updateShowModalError(!showModalError);
  };

  const radioOnChange = (e) => {
    updatePaymentMethod(e.target.value);
  };

  const onClick = () => {
    if (paymentMethod === "none") return;
    const paymentState =
      paymentMethod === PAYMENT_METHODS.CASH
        ? PaymentModalStates.CONTADO_METHOD
        : paymentMethod === PAYMENT_METHODS.CREDIT
        ? PaymentModalStates.CREDIT_METHOD
        : PaymentModalStates.COLLECTION_PAYMENT_METHOD;

    if (paymentState === PaymentModalStates.CONTADO_METHOD) {
      const quotation_ids = invoices.map((invoice) => {
        return invoice.id;
      });
      getQuotationQuotedVolantes.execute({ invoices });

      loadUpfrontManual.execute({ quotation_ids });
      updatePaymentState(paymentState);
      if (paymentMethod === PAYMENT_METHODS.CASH) {
        setShowModalContadoInformation(true);
      }
      return;
    }
    if (paymentState === PaymentModalStates.COLLECTION_PAYMENT_METHOD) {
      const quotation_ids = invoices.map((invoice) => {
        return invoice.id;
      });
      getQuotationQuotedVolantes.execute({ invoices });
      loadUpfront.execute({ quotation_ids });
      updatePaymentState(paymentState);
      return;
    }
    if (paymentState === PaymentModalStates.CREDIT_METHOD) {
      updateWaitingServerResponse(true);
      const quotation_ids = invoices.map((invoice) => {
        return invoice.id;
      });
      getQuotationQuotedVolantes.execute({ invoices });
      networkBackendRequest(`/invoices/estimate/credit/`, HTTP_METHODS.GET, {
        payment_type_option: "credit",
        quotation_ids: quotation_ids,
      })
        .then((response) => response.json())
        .then((responseJson) => {
          const creditRucOptions = responseJson.credit_payer_ruc_options;
          const currentPayerItems = creditRucOptions.map((payerItem) => {
            return {
              remainingCredit: payerItem.available_credit,
              totalCredit: payerItem.total_credit,
              payerRuc: payerItem.ruc,
              payerRucName: payerItem.name,
              payerRucOption: payerItem.option,
              allowed: payerItem.allowed,
              label: payerItem.label,
            };
          });

          updatePayerItems([...currentPayerItems]);
          updatePaymentState(paymentState);
        })
        .catch((error) => {
          const errorMessage = getErrorValueResponse(error);
          updateMessageError(errorMessage);
          toggleModalError();
        });
    } else updatePaymentState(paymentState);
  };

  return (
    <Container>
      <h1>¿Cómo desea pagar su carga?</h1>
      <h2>
        Monto a cancelar: <span>{formatMoney(totalAmount, useDollars)}</span>
      </h2>
      <div className="rows-wrapper">
        {BETA_FEATURES.CONTADO_PAYMENT && (
          <Authorization actions={["invoice.create_invoice_upfront_manual"]}>
            <Row>
              <div className="option-container">
                <input
                  className="clickable-element"
                  type="radio"
                  value={PAYMENT_METHODS.CASH}
                  onChange={radioOnChange}
                  checked={paymentMethod === PAYMENT_METHODS.CASH}
                />
                <p>Al contado</p>
              </div>
            </Row>
          </Authorization>
        )}
        <Authorization actions={["invoice.create_invoice_credit"]}>
          <Row>
            <div className="option-container ">
              <input
                className="clickable-element"
                type="radio"
                value={PAYMENT_METHODS.CREDIT}
                onChange={radioOnChange}
                checked={paymentMethod === PAYMENT_METHODS.CREDIT}
              />
              <p>Crédito</p>
            </div>
          </Row>
        </Authorization>
        <Authorization actions={["invoice.create_invoice_upfront"]}>
          <Row>
            <div className="option-container ">
              <input
                className="clickable-element"
                type="radio"
                value={PAYMENT_METHODS.COLLECTION}
                onChange={radioOnChange}
                checked={paymentMethod === PAYMENT_METHODS.COLLECTION}
              />
              <p>Recaudo</p>
            </div>
          </Row>
        </Authorization>
      </div>
      <MainButton
        onClick={onClick}
        disabled={waitingServerResponse || paymentMethod === "none"}
        isLoading={waitingServerResponse}
      >
        {waitingServerResponse && (
          <img src={LoadingSpinner} className="icon" alt="Processing request" />
        )}
        Pagar ahora
      </MainButton>
      {showModalError && (
        <ConfirmationModal
          message={messageError}
          onAccept={() => {
            updateMessageError("");
            updateShowModalError(false);
            toggleModal(true);
          }}
          title={`Atención`}
          toggleModal={() => {
            updateMessageError("");
            updateShowModalError(false);
            toggleModal(true);
          }}
        />
      )}
    </Container>
  );
}

export default PaymentMethod;
